
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill":"currentColor"},style,staticStyle],
              attrs: Object.assign({"style":"fill: currentColor","width":"96px","height":"96px","viewBox":"0 0 96 96","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Icons-/-System-/-Info---Dark","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}},[_c('path',{attrs:{"id":"Shape","d":"M46,36 L50,36 C53.3137085,36 56,38.6862915 56,42 L56,78 C56,81.3137085 53.3137085,84 50,84 L46,84 C42.6862915,84 40,81.3137085 40,78 L40,42 C40,38.6862915 42.6862915,36 46,36 Z M46,12 L50,12 C53.3137085,12 56,14.6862915 56,18 L56,22 C56,25.3137085 53.3137085,28 50,28 L46,28 C42.6862915,28 40,25.3137085 40,22 L40,18 C40,14.6862915 42.6862915,12 46,12 Z","fill-rule":"nonzero"}})])])
          )
        }
      }
    